'use client';

import React, { forwardRef, useRef, useContext } from 'react';
import omit from 'lodash-es/omit';
import clsx from 'clsx';
import { SheetModal, type GiveawaySheetModalReturnRef } from 'app/components/SheetModal';
import { useBuyerProductStore } from 'app/store/product';
import { ScreenContext } from '@shared/ui';
import { ProductCardList, type ProductCardListPropType } from '../ProductCard';
import STYLE from './ProductGiveaway.module.scss';

interface ProductGiveawayPropType extends ProductCardListPropType {}

export const ProductGiveaway = forwardRef<HTMLDivElement, ProductGiveawayPropType>(
    (props, ref) => {
        const { isBuyer } = props;

        const { status: screenStatus = { isMobile: false } } = useContext(ScreenContext);

        const { product, productQuantity, promoProductGiveaway } = useBuyerProductStore();

        const imperativeHandleRef = useRef<GiveawaySheetModalReturnRef>(null);

        const handleShowGiveaway = () => {
            if (!product) {
                return;
            }

            const media = product.medias?.find((i) => i.type === 'image');

            imperativeHandleRef.current?.showGiveaway({
                product: product,
                quantity: productQuantity,
                name: product.name,
                image: media as ProductDisplayMedia,
                price: product.price,
            });
        };

        return (
            <>
                <ProductCardList
                    className={clsx(STYLE.root, 'scroll')}
                    style={{
                        '--shop-ui-custom-product-card-list-items': '3.3',
                        ...props.style,
                    }}
                    {...omit(props, ['style', 'className'])}
                    ref={ref}
                    onClick={handleShowGiveaway}
                    products={(promoProductGiveaway?.products as Product[]) || []}
                    isLoading={false}
                />
                {isBuyer && (
                    <SheetModal.Giveaway
                        ref={imperativeHandleRef}
                        isMobile={screenStatus.isMobile}
                    />
                )}
            </>
        );
    }
);

ProductGiveaway.displayName = 'ProductGiveaway';
